// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","App-logo":"App_App-logo__25k4o","App-logo-spin":"App_App-logo-spin__1e7sv","App-header":"App_App-header__xLkWl","App-intro":"App_App-intro__1wFdV"};